<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">经销商公关团购下单</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="pageMode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY001', 'WLY002', 'WLY015', 'WLYALL']) && !conditions.OBJECT_ID">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
        </template>
        <template v-if="conditions.OBJECT_ID && !showEdit">
          <template v-if="conditions.STATUS === 'E0004'">
            <template v-if="$_has(['WLY001', 'WLY002', 'WLYALL']) && conditions.change">
              <form-button @click="orderModify">修改</form-button>
            </template>
            <template v-if="$_has(['WLY014', 'WLY015']) && conditions.confirm">
              <form-button @click="confirmGGTG">确认收货</form-button>
            </template>
          </template>
          <template v-else-if="['E0003', 'E0007'].includes(conditions.STATUS) && $_has(['WLYALL'])">
            <form-button @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="['E0008', 'E0014'].includes(conditions.STATUS) && $_has(['WLY002', 'WLYALL'])">
            <form-button @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="conditions.STATUS === 'E0002'">
            <template v-if="$_has(['WLYALL', 'WLY001', 'WLY002'])">
              <form-button @click="orderModify">修改</form-button>
            </template>
            <template v-if="$_has('WLY015')">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
          </template>
          <template v-else-if="conditions.STATUS !== 'E0006' && $_has('WLYALL')">
            <form-button v-if="!showEdit" @click="showEdit = true">修改</form-button>
          </template>
          <template v-if="conditions.STATUS !== 'E0006' && $_has(['WLYALL', 'WLY002']) && !showEdit">
            <form-button @click="orderlock('UNLOCK')">订单解锁</form-button>
          </template>
        </template>
        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="orderDisplay">显示</form-button>
          <template v-if="conditions.STATUS === 'E0002'">
            <form-button v-if="$_has(['WLY001', 'WLYALL'])" type="primary" @click="changeStatus('SAVE')">保存</form-button>
            <form-button v-if="$_has(['WLYALL', 'WLY015'])" icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0003' && $_has(['WLYALL', 'WLY013'])">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <!-- <form-button @click="changeStatus('REJECT')">审核拒绝</form-button> -->
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0004' && conditions.cancel && $_has(['WLY002', 'WLYALL'])">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0005'">
            <form-button v-if="$_has(['WLY001', 'WLYALL'])" type="primary" @click="changeStatus('SAVE')">保存</form-button>
            <form-button v-if="$_has(['WLYALL'])" icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0007'">
            <form-button v-if="$_has('WLYALL')" type="primary" @click="changeStatus('SAVE')">保存</form-button>
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <!-- <form-button @click="changeStatus('REJECT')">审核拒绝</form-button> -->
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="['E0008', 'E0014'].includes(conditions.STATUS) && $_has(['WLY002', 'WLYALL'])">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <!-- <form-button @click="changeStatus('REJECT')">审核拒绝</form-button> -->
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0013' && $_has(['WLY002','WLY003','WLYALL'])">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
        <form-button v-if="conditions.diyc === 'X'" @click="customized('c')">定制创建</form-button>
        <form-button v-if="conditions.diyd === 'X'" @click="customized('d')">定制显示</form-button>
        <form-button v-if="conditions.c_ok === 'X'" @click="changeStatus('C_OK')">经销商确认</form-button>
      </div>

      <el-form
        ref="form"
        inline
        size="mini"
        :model="conditions"
        :rules="rules"
        :show-message="false"
        label-width="100px"
        :disabled="isEdit"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="订单编号">
              <el-input
                :value="conditions.OBJECT_ID"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="订单类型">
              <el-select
                :value="conditions.PROCESS_TYPE"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0043']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                :value="conditions.CUST_NAME"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="CUSTOMER" label="客户编号">
              <wly-input
                v-model="conditions.CUSTOMER"
                input-type="customer"
                :disabled="role.ROLE === 'WLY001'"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog($event, 'client')"
              />
              <!-- <el-input
                v-model="conditions.CUSTOMER"
                placeholder="请输入"
                type="text"
                @focus="openSelectDialog('client')"
              /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="BUSOPPID" label="商机编号">
              <el-input
                v-model="conditions.BUSOPPID"
                type="text"
                clearable
                @focus="openSelectDialog($event, 'businessOpp')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="商机名称">
              <el-input
                :value="conditions.BUSINAME"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.CUSTOMER_TYPE" placeholder="" clearable disabled>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="GRPUTID" label="团购单位">
              <el-input
                v-model="conditions.GRPUTID"
                type="text"
                clearable
                @focus="openSelectDialog($event, 'groupUnit')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="团购单位名称">
              <el-input
                :value="conditions.GRPNAME"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="喷码方式" prop="PENGMETHOD">
              <el-select v-model="conditions.PENGMETHOD" placeholder="" @change="penMethodChange">
                <el-option label="团购订单号" value="O" />
                <el-option label="团购单位" value="U" />
                <el-option label="祝福语" value="S" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="企业内购">
              <el-checkbox v-model="conditions.ZZFLD00009CX" true-label="X" false-label="" @change="checkboxChange" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否盒外刻字">
              <el-checkbox v-model="conditions.ZZFLD000099" true-label="X" false-label="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input v-model="conditions.ZCUSTOM_NAME" placeholder="" clearable :disabled="isEdit" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="role.ROLE === 'WLY015'||conditions.ZZFLD00002J === 'V015'">
            <el-form-item label="发货类型" prop="ZZFLD00002K">
              <el-select v-model="conditions.ZZFLD00002K" placeholder="" clearable>
                <el-option
                  v-for="item in selectDataOptions['A0083']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="外箱喷码内容">
              <el-input
                v-model="conditions.ZZFLD000098"
                :disabled="conditions.ZZFLD000001 != '0005000274' && conditions.ZZFLD000001 != '0005000324'"
                type="textarea"
                rows="4"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.ZZFLD000028"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                :value="conditions.ZZFLD00002D_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                :value="conditions.POSTING_DATE"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                :value="conditions.STATUS"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0041']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销区域" prop="ZZFLD000001">
              <el-select
                v-model="conditions.ZZFLD000001"
                placeholder=""
                type="select"
                :disabled="!selectDataOptions.orgList || selectDataOptions.orgList.length == 1"
                @change="saleCenterChange"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input
                :value="conditions.ZZFLD00003E"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省区">
              <el-input
                :value="conditions.ZZFLD000002_TEXT"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input
                :value="conditions.ZZFLD000003_TEXT"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                :value="conditions.ZZFLD000004_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="运达方" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00008T" label="收货方编码">
              <el-input
                v-model="conditions.ZZFLD00008T"
                type="text"
                @focus="openSelectDialog($event, 'contact')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货方名称">
              <el-input
                :value="conditions.ZZFLD00008T_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人">
              <el-input
                :value="conditions.ZZFLD00002L"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系电话">
              <el-input
                :value="conditions.ZZFLD00002M"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货地址">
              <el-input :value="conditions.ZZFLD00002N" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-btns">
          <span class="form-btns-label">新开发客户？</span>
          <el-button
            size="mini"
            type="primary"
            @click="openSelectDialog($event, 'newClient', {}, 'client')"
          >新增我的客户</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="openSelectDialog($event, 'newClient', {}, 'address')"
          >新增地址</el-button>
        </div>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售订单行项目" :custome-config="() => vxeShowCustom('orderDetail')">
        <template #button v-if="conditions.STATUS === 'E0001' || conditions.STATUS === 'E0002'">
          <table-button :disabled="isEdit" name="save" tip="保存" @click="updateSaleItem" />
          <table-button v-if="!$_has('WLY001')" :disabled="isEdit" name="add" tip="新增" @click="tableEvent('add')" />
          <table-button v-if="!$_has('WLY001')" :disabled="isEdit" name="delete" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="orderDetail"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #ZZFLD00002Q_D="{row}">
            <el-input
              v-model="row.ZZFLD00002Q_D"
              size="mini"
              placeholder=""
              suffix-icon="el-icon-more"
              :disabled="isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002')"
              @focus="openSelectDialog($event, 'planType', row)"
            />
          </template>
          <template #ORDERED_PROD="{row}">
            <wly-input
              v-model="row.ORDERED_PROD"
              size="mini"
              :disabled="isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002')"
              input-type="salesProduct"
              :sales-query-params="productParams"
              @enter="handleEnter(...arguments, row)"
              @handleSuffixClick="openSelectDialog($event, 'product', row)"
            />
          </template>
          <template #ZZFLD000009="{row}">
            <el-input
              v-model="row.ZZFLD000009"
              size="mini"
              type="number"
              :disabled="isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002')"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD00002I="{row}">
            <el-input
              v-model="row.ZZFLD00002I"
              size="mini"
              type="number"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : (isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002'))"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD000008="{row}">
            <el-input
              v-model="row.ZZFLD000008"
              size="mini"
              :disabled="isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002')"
            />
          </template>
          <template #ZZFLD00002A="{row}">
            <el-select
              v-model="row.ZZFLD00002A"
              size="mini"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : (isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002'))"
              placeholder=""
            >
              <el-option
                v-for="item in selectDataOptions['A0037']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #ZZFLD00002B="{row}">
            <el-checkbox
              v-model="row.ZZFLD00002B"
              true-label="X"
              false-label=""
              disabled
            >是</el-checkbox>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #FILENAME="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="关联单据" :custome-config="() => vxeShowCustom('gridOptionsLinkBill')">
        <vxe-grid
          ref="gridOptionsLinkBill"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsLinkBill.columns"
          :data="gridOptionsLinkBill.data"
        />
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('history')">
        <vxe-grid
          ref="history"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <plan-type-select
          v-if="showDialogType === 'planType'"
          ref="dialogEdit"
          :head="conditions"
          :item="currentDetail"
        />
        <greeting-select v-if="showDialogType === 'greeting'" ref="dialogEdit" />
        <client-add
          v-if="showDialogType === 'newClient'"
          ref="dialogEdit"
          :mode="mode"
          :init-data="initClientAddData"
        />
        <business-opportunity-select v-if="showDialogType === 'businessOpp'" ref="dialogEdit" />
        <group-client-select
          v-if="showDialogType === 'groupUnit'"
          ref="dialogEdit"
          :info="conditions"
        />
        <client-select
          v-if="showDialogType === 'client' || showDialogType === 'receiveUnit'"
          ref="dialogEdit"
        />
        <client-group-arrival-select
          v-if="showDialogType === 'contact'"
          ref="dialogEdit"
          mode="GGTG"
          :info="conditions"
        />
        <sale-product-select
          v-if="showDialogType === 'product'"
          ref="dialogEdit"
          :info="productParams"
        />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="iframeDialog" width="80%" :title="iframeTitle" top="5vh">
      <iframe :src="iframeSrc" frameborder="0" width="100%" height="700px" />
    </el-dialog>
  </div>
</template>
<script>
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSapSingleClientInfo, apiOrderLock } from '@/api/common'
import { apiGGTGUpdateSaleItem, apiGGTGSave, getOrderDetail, apiGGTGConfirm } from '@/api/sap/order-sap'

import { apiInitClientAdd, apiClientAdd } from '@/api/client'
const SaleProductSelect = () => import('@/components/dialog/SaleProductSelect')
const ClientSelect = () => import('@/components/dialog/ClientSelect')
const ClientAdd = () => import('@/components/dialog/ClientAdd.vue')
const BusinessOpportunitySelect = () => import('@/components/dialog/BusinessOpportunitySelect.vue')
const GroupClientSelect = () => import('@/components/dialog/GroupClientSelect')
const ClientGroupArrivalSelect = () => import('@/components/dialog/ClientGroupArrivalSelect')
const GreetingSelect = () => import('@/components/dialog/GreetingSelect')
const PlanTypeSelect = () => import('@/components/dialog/PlanTypeSelect')
import { URLS } from '@/api/baseUrl'
export default {
  components: {
    SaleProductSelect,
    ClientSelect,
    ClientAdd,
    BusinessOpportunitySelect,
    GroupClientSelect,
    ClientGroupArrivalSelect,
    GreetingSelect,
    PlanTypeSelect
  },
  data() {
    const rules = {
      CUSTOMER: [{ required: true, message: '请选择客户', trigger: 'change' }],
      // BUSOPPID: [{ required: true, message: '请选择商机', trigger: 'change' }],
      ZZFLD00008T: [{ required: true, message: '请选择收货方单位编码', trigger: 'change' }],
      GRPUTID: [{ required: true, message: '请选择团购单位', trigger: 'change' }],
      PENGMETHOD: [{ required: true, message: '请选择喷码方式', trigger: 'change' }],
      ZZFLD00002K: [{ required: true, message: '请选择发货类型', trigger: 'change' }],
      ZZFLD000001: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
    }
    return {
      loading: false,
      rules,
      iframeSrc: '',
      showEdit: false,
      iframeDialog: false,
      iframeTitle: '',
      pageMode: 'add',
      errorList: [],
      validRules: {
        ORDERED_PROD: [{ required: true }],
        ZZFLD000009: [{ required: true }],
        ZZFLD00002Q_D: [{ required: true }]
      },
      mode: '',
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      clientMode: 'add',
      currentData: {},
      selectDataOptions: {},
      productParams: {
        PROCESS_TYPE: 'ZS02',
        CUSTOMER: '',
        ZZFLD00002J: 'V013',
        mode: 'GGTG'
      },
      conditions: {
        OBJECT_ID: '', // 订单编号
        PROCESS_TYPE: 'ZS02', // 订单类型
        CUSTOMER: '', // 客户编码
        CUST_NAME: '', // 客户名称
        CUSTOMER_TYPE: '', // 客户类型
        ZZFLD00000: '', // 审核意见
        ZZFLD000028: '', // 备注
        ZZFLD00002D: '', // 创建人编号
        ZZFLD00002D_DSCR: '', // 创建人描述
        POSTING_DATE: '', // 创建时间
        STATUS: 'E0001', // 状态
        ZZFLD000001: '', // 营销单元
        ZZFLD00003E: '', // 基地
        ZZFLD000002: '', // 省区
        ZZFLD000003: '', // 城市
        ZZFLD000004: '', // 业务员
        ZZFLD000004_DSCR: '', // 业务员描述
        ZCUSTOM_NAME: '',
        // 原系统角色为 WLY015 的 客户性质为 V015 否则 V013
        ZZFLD00002J: 'V013', // 客户性质
        ZZFLD00002K: '', // 发货类型
        ZZFLD00002L: '', // 收货联系人
        ZZFLD00002M: '', // 收货联系电话
        ZZFLD00008T: '', // 收货方
        ZZFLD00008T_DSCR: '', // 收货方
        BUSOPPID: '', // 商机编码
        PENGMETHOD: '', // 喷码方式
        BUSINAME: '', // 商机名称
        GRPUTID: '', // 团购单位编码
        GRPNAME: '', // 团购单位名称
        INFOTP: '', // 团购信息类型
        ZZFLD000098: '', // 喷码内容
        ZZFLD000099: '',
        ZZFLD00009CX: '',
        ZZFLD00003C: 'WEB'
      },
      currentDetail: {},
      gridOptions: {
        columns: [
          { filed: 'checkbox', type: 'checkbox', title: '', width: 40 },
          {
            field: 'NUMBER_INT',
            title: '行号',
            width: 50,
            formatter: ({ cellValue }) => Number(cellValue)
          },
          {
            field: 'YEAR',
            title: '计划年度',
            width: 120,
            visible: false
          },
          {
            field: 'ZZFLD00002Q_D',
            title: '计划类型',
            visible: false,
            width: 120,
            slots: {
              default: 'ZZFLD00002Q_D'
            },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 180,
            slots: { default: 'ORDERED_PROD' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 250
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 180
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80

          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80

          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80,
            slots: { default: 'ZZFLD000009' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80

          },
          {
            field: 'ZZFLD00002X',
            title: '含税单价',
            width: 100

          },
          {
            field: 'ZZFLD00002Z',
            title: '税价合计',
            width: 100

          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100

          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180

          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180

          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180

          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180

          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180

          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: { default: 'ZZFLD00002B' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' },
            params: { bgEdit: true }
          }
        ],
        data: [],
        delData: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'FILENAME' }},
          { field: 'MIMETYPE', title: '附件类型' },
          { field: 'FILELENGTH', title: '大小', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'CREATED_DATE', title: '上传日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CREATED_TIME', title: '上传时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: [],
        delData: []
      },
      gridOptionsLinkBill: {
        buttons: [],
        columns: [
          {
            field: 'ZZFLD000011',
            title: '单据编号'
          },
          {
            field: 'ZZFLD000012_TEXT',
            title: '单据类型'
          },
          {
            field: 'ZZFLD000013',
            title: '创建日期',
            formatter: ({ cellValue }) => formatSapDate(cellValue)
          }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ZZFLD00000U', title: '操作人' },
          { field: 'ZZFLD000031', title: '操作人姓名' },
          { field: 'ZZFLD00000V_TEXT', title: '状态' },
          { field: 'ZZFLD00000W', title: '变更日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'ZZFLD00000X', title: '变更时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      initClientAddData: {}
    }
  },
  computed: {
    isEdit() {
      if (this.conditions.OBJECT_ID) {
        return !this.showEdit
      } else {
        return false
      }
    },
    ...mapGetters(['role', 'customerInfo'])
  },
  watch: {
    'conditions.CUSTOMER': {
      handler(nv) {
        this.productParams.CUSTOMER = nv
      }
    },
    'gridOptions.data': {
      handler(nv, ol) {
        nv.forEach((item, i) => {
          item.NUMBER_INT = (i + 1) * 10
        })
      },
      deep: true
    },
    'conditions.CUST_NAME': {
      handler(nv) {
        this.productParams.zzfld000001 = this.conditions.ZZFLD000001
      }
    }
  },
  created() {
    const pageQuery = this.$route.query
    if (pageQuery?.object_id) {
      this.pageMode = 'edit'
      this.initOrderInfoById(pageQuery.object_id, 1)
    } else {
      if (this.role.ROLE === 'WLY001') {
        const orgList = this.customerInfo.yxdy.filter(v => v.mc_short !== '其他销售类型')
        this.conditions.CUSTOMER = this.customerInfo.info.partner
        this.conditions.CUSTOMER_TYPE = this.customerInfo.info.zzfld000016
        this.conditions.CUST_NAME = this.customerInfo.info.name_org1
        this.conditions.ZZFLD000002 = this.customerInfo.info.region
        this.conditions.ZZFLD000002_TEXT = this.customerInfo.info.bezei
        this.conditions.ZZFLD000003 = this.customerInfo.info.city_code
        this.conditions.ZZFLD000003_TEXT = this.customerInfo.info.city_name
        this.conditions.ZZFLD000004 = this.customerInfo.info.sales_emp
        this.conditions.ZZFLD000004_DSCR = this.customerInfo.info.sales_emp_name
        this.productParams.CUSTOMER = this.customerInfo.info.partner
        this.$set(this.selectDataOptions, 'orgList', orgList)
        this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
        this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
      } else if (this.role.ROLE === 'WLY015') {
        this.conditions.ZZFLD00002J = 'V015'
        this.productParams.ZZFLD00002J = 'V015'
      }
      this.conditions.ZZFLD00002D = this.role.USER_BP
      this.conditions.ZZFLD00002D_DSCR = this.role.login_user
      this.conditions.POSTING_DATE = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.tableEvent('add')
    }
    // 折扣类型
    this.getSelectDictDataOrigin('A0037')
    // 销售订单状态
    this.getSelectDictDataOrigin('A0041')
    // 销售订单类型
    this.getSelectDictDataOrigin('A0043')
    // 是否选项
    this.getSelectDictDataOrigin('B0099')
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0083')

  },
  methods: {
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    // 根据id查询订单信息
    async initOrderInfoById(OBJECT_ID, type = 0) {
      this.loading = true
      try {
        const res = await getOrderDetail({ OBJECT_ID })
        if (res?.MSGTYPE === 'S') {
          const { DATA } = res
          Object.assign(this.conditions, DATA.INFO)
          this.conditions.invo_infoid = res.INVO_INFOID
          this.conditions.ztab00002s = res.ZTAB00002S
          this.conditions.change = res.CHANGE
          this.conditions.cancel = res.CANCEL
          this.conditions.confirm = res.CONFIRM
          this.conditions.diyc = res.DIYC
          this.conditions.diyd = res.DIYD
          this.conditions.c_ok = res.C_OK
          this.gridOptions.data = DATA.ITEM || []
          this.gridOptionsFile.data = DATA.ATTACHMENT || []
          this.gridOptionsHistory.data = DATA.HISTORY || []
          this.gridOptionsLinkBill.data = DATA.CONNECT || []

          const flag = this.gridOptions.data.some(v => v.ZZFLD00002Q_D)
          if (flag) {
            const cols = [
              {
                field: 'YEAR',
                title: '计划年度',
                width: 120,
                visible: true
              },
              {
                field: 'ZZFLD00002Q_D',
                title: '计划类型',
                visible: true,
                width: 120,
                editRender: {},
                params: { bgEdit: true },
                slots: {
                  default: 'ZZFLD00002Q_D'
                }
              }
            ]
            this.gridOptions.columns.splice(2, 2, ...cols)
          }

          type && this.initCustome()
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    penMethodChange(e) {
      // 祝福语需要弹窗选择祝福语
      if (e === 'S') {
        this.openSelectDialog(undefined, 'greeting')
      } else if (e === 'U') {
        this.conditions.ZZFLD000098 = this.conditions.GRPNAME
      } else {
        this.conditions.ZZFLD000098 = ''
      }
    },
    // 确认收货
    async confirmGGTG() {
      await this.$confirm('请线下确认收货方已收到货物,点击确定按钮进行收货确认!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const params = {
        user_bp: this.role.USER_BP,
        head: this.conditions
      }
      const res = await apiGGTGConfirm(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
      } else {
        this.errorList = [res.message]
      }
    },
    async orderModify() {
      const res = await this.orderlock('ADD')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = true
    },
    async orderDisplay() {
      const res = await this.orderlock('DELETE')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = false
    },
    // 订单解锁
    async orderlock(mode) {
      this.errorList = []
      const params = {
        type: this.conditions.PROCESS_TYPE,
        number: this.conditions.OBJECT_ID,
        status: mode === 'ADD' ? 1 : 2
      }
      if (mode === 'UNLOCK') {
        await this.$confirm('解锁前请确认当前没有其他人修改此订单！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
      const { data } = await apiOrderLock(params)
      if (data.status && params.status === 1) {
        this.errorList = [data.message]
        return false
      }
      return true
    },
    customized(type) {
      if (type === 'd') {
        // http://10.0.134.120:9031/distributor/
        this.iframeSrc = `${URLS.GGTG_DZJURL}?code=&orderid=${this.conditions.OBJECT_ID}&page=diywine_query_custominfo`
        this.iframeTitle = '定制显示'
      } else {
        this.iframeSrc = `${URLS.GGTG_DZJURL}?code=&orderid=${this.conditions.OBJECT_ID}&page=diywine_create_customV2`
        this.iframeTitle = '定制创建'
      }
      this.iframeDialog = true
    },
    checkboxChange(e) {
      if (e) {
        this.conditions.ZZFLD000098 = '企业内购'
      } else {
        this.conditions.ZZFLD000098 = ''
      }
    },
    async confirmMode(type) {
      const types = {
        SUBMIT: '提交',
        CANCEL: '取消',
        REJECT: '审核拒绝',
        APPROVE: '审核通过'
      }
      if (!types[type]) {
        return Promise.resolve()
      }
      await this.$confirm(`是否确认${types[type]}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 保存 提交 确认  新建 E0001,已保存待提交 E0002,已提交待审核 E0003, 审核通过 E0004,审核拒绝 E0005,已取消 E0006
    changeStatus(status) {
      this.errorList = []
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          // await this.confirmMode(status)
          // 验证一下是否有计划类型列，如果有，需要有值
          const planCol = this.gridOptions.columns.find(item => {
            return item.field === 'ZZFLD00002Q_D'
          })
          try {
            if (planCol.visible) {
              this.gridOptions.data.forEach(row => {
                if (!row.ZZFLD00002Q_D) {
                  throw new Error('请选择计划类型！')
                }
              })
            }
          } catch (e) {
            this.errorList = [e.message]
            return
          }
          if (status === 'C_OK') {
            await this.$confirm('请线下确认收货方已收到货物,再点击此按钮进行收货确认!', '提醒', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
          }

          this.loading = true

          const params = {
            user_bp: this.role.USER_BP,
            MODE: status,
            info: this.conditions,
            item: this.gridOptions.data.concat(this.gridOptions.delData),
            ATTACHMENT: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
          }

          params.user_bp = this.role.USER_BP
          params.role = this.role.ROLE
          const result = await apiGGTGSave(params)

          if (result?.MSGTYPE === 'S') {
            this.$message.success(result.MESSAGE)
            this.gridOptions.delData = []
            this.gridOptionsFile.delData = []
            this.conditions.OBJECT_ID = result.DATA.INFO.OBJECT_ID
            this.orderDisplay()
          } else {
            this.errorList.push(result.MESSAGE)
            this.loading = false
            return
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        partner: this.conditions.CUSTOMER,
        user_bp: this.role.USER_BP
      }
      const { data } = await apiSapSingleClientInfo(params)
      const orgList = data.yxdy.filter(v => v.mc_short !== '其他销售类型')
      this.$set(this.selectDataOptions, 'orgList', orgList)
    },
    // 初始化数据字典
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 选择营销单元
    saleCenterChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD00003E = checkedData.mc_short_jd
      this.productParams.zzfld000001 = e
      this.errorList = []
      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsFile.data = []
      this.gridOptionsFile.delData = []
      this.gridOptionsLinkBill.data = []
      this.gridOptionsHistory.data = []

      this.tableEvent('add')
    },
    tableEvent(btn) {
      const orderDetailsEmpty = {}
      this.gridOptions.columns.forEach(v => {
        !v.type && (orderDetailsEmpty[v.field] = '')
      })
      switch (btn) {
        case 'add':
          // orderDetailsEmpty.NUMBER_INT = (this.gridOptions.data.length + 1) * 10
          this.gridOptions.data.push(orderDetailsEmpty)
          break
        case 'del':
          this.delDetail()
          break
      }
    },
    async delDetail() {
      const checkedList = this.$refs.orderDetail.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效数据！')
      checkedList.forEach(item => {
        item.MODE = 'D'
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptions.delData = this.gridOptions.delData.concat(checkedList.filter(v => v.GUID))
      }
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(checkedList.filter(v => v.GUID))
      }
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const dateTime = new Date().getTime()

        const fileData = {
          FILENAME: file.name,
          MIMETYPE: file.raw.type,
          DOC_TYPE: file.raw.type,
          XCONTENT: strArr,
          FILELENGTH: file.size,
          ZZFLD00002D: _this.role.ROLE,
          ZZFLD00002D_DSCR: _this.role.login_user,
          CREATED_DATE: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          CREATED_TIME: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 下载附件
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT, row.FILENAME)
    },
    // 添加客户地址
    async addGroupArrivalCustomer(res) {
      const result = await apiClientAdd(res)
      if (result.MSGTYPE === 'S') {
        this.$message.success(result.MESSAGE)
      } else {
        return this.$message.warning(result.MESSAGE)
      }

      this.conditions.ZZFLD00008T_DSCR = result.DATA.NAME_LAST
      this.conditions.ZZFLD00008T = result.DATA.PARTNER
      this.conditions.ZZFLD00002L = result.DATA.C_O_NAME
      this.conditions.ZZFLD00002M = result.DATA.TEL_NUMBER
      this.conditions.ZZFLD00002N = result.DATA.STREET
      this.conditions.MARKTSPT = result.DATA.MARKTSPT

      this.showDialog = false
    },
    async checkClientAdd(mode) {
      if (mode === 'address' && !this.conditions.ZZFLD00008T) {
        return this.$message.warning('请选择收货方')
      }
      // 初始化新增数据
      const params = {
        mode: mode === 'client' ? '' : 'X',
        head: this.conditions
      }
      params.role = this.role.ROLE
      const result = await apiInitClientAdd(params)
      if (result?.MSGTYPE !== 'S') {
        return this.$message.warning(result.MESSAGE)
      }
      const { DATA } = result
      this.initClientAddData = { head: DATA.HEAD, info: DATA.INFO }
      this.mode = mode
      this.dialogTitle = mode === 'client' ? '新增客户' : '新增地址'
      this.showDialog = true
    },
    // 打开窗口
    openSelectDialog(e, type, row = {}, mode = 'add') {
      e && e.target.blur()
      this.currentDetail = row
      this.showDialogType = type
      if (type === 'newClient') {
        return this.checkClientAdd(mode)
      }

      this.dialogTitle = {
        product: '产品选择',
        receiveUnit: '收货方单位选择',
        contact: '收货方选择',
        groupUnit: '团购客户选择',
        businessOpp: '商机选择',
        greeting: '祝福语选择',
        planType: '计划类型选择'
      }[type]
      this.showDialog = true
    },
    selectClient(res) {
      const orgList = res.orgList.filter(v => v.mc_short !== '其他销售类型')
      this.conditions.CUSTOMER = res.partner
      this.conditions.CUSTOMER_TYPE = res.zzfld000016
      this.conditions.CUST_NAME = res.name_org1
      this.conditions.ZZFLD000002 = res.region
      this.conditions.ZZFLD000002_TEXT = res.bezei
      this.conditions.ZZFLD000003 = res.city_code
      this.conditions.ZZFLD000003_TEXT = res.city_name
      this.conditions.ZZFLD000004 = res.sales_emp
      this.conditions.ZZFLD000004_DSCR = res.sales_emp_name
      this.productParams.CUSTOMER = res.partner
      this.$set(this.selectDataOptions, 'orgList', orgList)
      this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
      this.conditions.ZZFLD00003E = orgList[0].mc_short_jd

      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsFile.data = []
      this.gridOptionsFile.delData = []
      this.gridOptionsLinkBill.data = []
      this.gridOptionsHistory.data = []

      this.tableEvent('add')
    },
    selectProduct(res) {
      for (const key in this.currentDetail) {
        if (!['NUMBER_INT'].includes(key)) {
          this.currentDetail[key] = ''
        }
      }
      this.currentDetail.ORDERED_PROD = res.PRODUCT_ID
      this.currentDetail.UNIT = res.MSEHT
      this.currentDetail.DESCRIPTION = res.SHORT_TEXT
      this.currentDetail.ZZFLD00002S = res.NORMS

      this.updateSaleItem()
    },
    receiveSelect(res) {
      this.conditions.ZZFLD00008T_DSCR = res.NAME_ORG1
      this.conditions.ZZFLD00008T = res.PARTNER
      this.conditions.ZZFLD00002L = res.C_O_NAME
      this.conditions.ZZFLD00002M = res.TEL_NUMBER
      this.conditions.ZZFLD00002N = res.STREET
    },
    async updateSaleItem() {
      this.errorList = []
      const params = {
        info: this.conditions,
        item: this.gridOptions.data
      }
      const result = await apiGGTGUpdateSaleItem(params)

      result.MSGS.forEach(msg => {
        msg.MSGTYPE === 'E' && this.errorList.push(msg.MESSAGE)
      })

      const { DATA, DISPLAY } = result
      const cols = [
        {
          field: 'YEAR',
          title: '计划年度',
          width: 120,
          visible: DISPLAY === 'TRUE'
        },
        {
          field: 'ZZFLD00002Q_D',
          title: '计划类型',
          visible: DISPLAY === 'TRUE',
          width: 120,
          editRender: {},
          params: { bgEdit: true },
          slots: {
            default: 'ZZFLD00002Q_D'
          }
        }
      ]
      this.gridOptions.columns.splice(2, 2, ...cols)
      Object.assign(this.conditions, DATA.INFO)
      this.gridOptions.data = DATA.ITEM
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        switch (this.showDialogType) {
          case 'product':
            this.selectProduct(res)
            break
          case 'client':
            this.selectClient(res)
            break
          case 'contact':
            this.receiveSelect(res)
            break
          case 'groupUnit':
            this.conditions.INFOTP = res.INFOTP
            this.conditions.GRPUTID = res.ID
            this.conditions.GRPNAME = res.OBJNAME
            break
          case 'businessOpp':
            this.conditions.BUSOPPID = res.ID
            this.conditions.BUSINAME = res.NAME
            break
          case 'newClient':
            this.addGroupArrivalCustomer(res)
            break
          case 'greeting':
            this.conditions.ZZFLD000098 = res.zzfld000098
            break
          case 'planType':
            this.currentDetail.YEAR = res.GJAHR
            this.currentDetail.ZZFLD00002Q = res.PLAN_TYPE
            this.currentDetail.ZZFLD00002Q_D = res.PLAN_TYPE_DESC
            this.currentDetail.SYS_FLAG = res.SYS_FLAG
            this.currentDetail.TRANSFER_ID = res.TRANSFER_ID
            break
        }
        if (this.showDialogType !== 'newClient') {
          this.showDialog = false
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      this.currentDetail = row

      switch (type) {
        case 'customer':
          this.selectClient(data)
          break
        case 'salesProduct':
          this.selectProduct(data)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/order-manage/groupBuyOrderEdit.vue